import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  noData: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 190px;
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    margin: 10px auto;
    width: 650px;
    height: ${(props: IWrapperProps) => props.noData && "unset"};
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    height: ${(props: IWrapperProps) => props.noData && "unset"};
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  .__react_component_tooltip {
    font-weight: 400;
  }

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

export const TitleText = styled.div`
  text-transform: capitalize;
  display: flex;
`;

export const TitleTooltip = styled.div`
  padding: 0 5px;
  font-size: 0.85em;
  color: rgb(187, 187, 187);
  position: relative;
  top: 1px;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #402680;
  }
`;

export const MemberSince = styled.div`
  font-weight: 300;
  font-size: 0.87em;

  ${mediaMaxWidth.phone} {
    display: none;
  }
`;

interface IBodyProps {
  noData: boolean;
}

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 5px 10px;
  justify-content: ${(props: IBodyProps) =>
    props.noData ? "center" : "space-around"};
  align-items: ${(props: IBodyProps) => props.noData && "center"};
  font-size: ${(props: IBodyProps) => props.noData && "0.95em"};

  ${mediaMaxWidth.phone} {
    padding: 20px 0 10px 0;
  }
`;

export const MultiRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;

  ${mediaMaxWidth.smallDesktop} {
    margin: 14px 0;
  }
`;

interface IColumnProps {
  flexSize: number;
}

export const Column = styled.div`
  display: flex;
  flex: ${(props: IColumnProps) => props.flexSize};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface IColumnTitleProps {
  small?: boolean;
}

export const ColumnTitle = styled.div`
  font-weight: 300;
  font-size: ${(props: IColumnTitleProps) =>
    props.small ? "0.8em" : "0.87em"};

  ${mediaMaxWidth.phone} {
    font-size: 0.85em;
  }
`;

interface IColumnValueProps {
  small?: boolean;
}

export const ColumnValue = styled.div`
  color: #333;
  font-weight: 500;
  font-size: ${(props: IColumnValueProps) => (props.small ? "1.2em" : "1.4em")};

  ${mediaMaxWidth.phone} {
    font-size: 1.2em;
  }
`;

export const InterviewGraphWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
  top: -2px;

  ${mediaMaxWidth.phone} {
    padding: 0 10px;
  }
`;

export const ArrowLine = styled.div`
  height: 20px;
  width: calc(100% - 40px);

  ${mediaMaxWidth.phone} {
    width: calc(100% - 25px);
  }
`;

interface IArrowProps {
  position: number;
  label: string;
}

export const Arrow = styled.div`
  height: 20px;
  width: ${(props: IArrowProps) => props.position === 0 && "4px"};
  width: ${(props: IArrowProps) => props.position === 1 && "6px"};
  width: ${(props: IArrowProps) => props.position === 2 && "8px"};
  width: ${(props: IArrowProps) =>
    props.position >= 3 && `${props.position}%}`};
  width: ${(props: IArrowProps) =>
    props.position === 100 && "calc(100% - 7px)"};
  position: relative;
  transition: 0.3s ease-in-out all;

  &:before {
    content: "${(props: IArrowProps) => props.label}";
    position: absolute;
    right: -50px;
    top: -10px;
    width: 100px;
    margin: 0 auto;
    font-style: italic;
    text-align: center;
    font-size: 0.8em;
    color: rgba(80, 80, 80);
    font-weight: 300;
  }

  &:after {
    content: "\f0d7";
    font-family: FontAwesome;
    position: absolute;
    right: -10px;
    font-size: 2em;
    top: -8px;
  }
`;

export const InterviewGraph = styled.div`
  height: 16px;
  display: flex;
  width: calc(100% - 40px);
  border-radius: 8px;
  overflow: hidden;

  ${mediaMaxWidth.phone} {
    width: calc(100% - 25px);
  }
`;

interface IGraphColumnProps {
  backgroundColor: string;
}

export const GraphColumn = styled.div`
  background-color: ${(props: IGraphColumnProps) => props.backgroundColor};
  height: 100%;
  display: flex;
  flex: 1;
`;

export const InterviewGraphTooltip = styled.div`
  height: 16px;
  width: 40px;
  display: flex;
  justify-content: center;
  font-size: 0.85em;
  color: rgb(187, 187, 187);
  position: absolute;
  right: 0;
  align-items: center;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #402680;
  }

  ${mediaMaxWidth.phone} {
    width: 35px;
  }
`;

export const PlaceholderText = styled.div`
  font-size: 0.95em;
  text-align: center;
  padding: 10px 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.smallDesktop} {
    padding: 20px 50px 10px 50px;
  }
`;
